import {seoScoreMetrics} from "@/plugins/SeoScore";
import {SeoScoreMetricName} from "@/model/SeoScore";
import {focusWorkspaceAnchor} from "@/utils/scroll";
import {firstAiVisibilityGap} from "@/service/lucyCoach";
import {Store} from "@/plugins/Store";

/**
 * Scrolls the article workspace to the block that belongs to an SEO factor.
 * Menu clicks and Improve (when it does not auto-apply) share this map.
 * AI visibility always lands on the first unfulfilled GEO point.
 */

export function focusSeoMetric(metricName: string): void {
    if (metricName === 'aiVisibility') {
        const gap = firstAiVisibilityGap(Store.getters.article);
        if (gap) {
            focusSeoMetric(gap);
            return;
        }
    }
    const metric = seoScoreMetrics[metricName as SeoScoreMetricName];
    if (!metric) {
        return;
    }
    metric.getClickAction?.();
    if (metric.domSelector) {
        focusWorkspaceAnchor(metric.domSelector, !!metric.getClickAction);
    }
}
